/** A refusal on the panel until it is dismissed, each dataset it names a link to that dataset. */

import { Fragment } from 'react';
import { Link } from 'react-router';
import { datasetUrl } from '@/constants/paths';
import { PanelNote } from './panel-note';
import { refusalParts, type Refusal } from './refusal';

interface RefusalNoteProps {
	refusal: Refusal;
	onDismiss: () => void;
	className?: string;
}

export const RefusalNote = ({ refusal, onDismiss, className }: RefusalNoteProps) => (
	<PanelNote role='alert' onDismiss={onDismiss} className={className}>
		{refusalParts(refusal).map((part, index) =>
			'dataset' in part ? (
				<Link
					key={index}
					to={datasetUrl(part.dataset.datasetId)}
					className='font-medium underline underline-offset-2 hover:text-amber-900'
				>
					{part.dataset.name}
				</Link>
			) : (
				<Fragment key={index}>{part.text}</Fragment>
			)
		)}
	</PanelNote>
);
